module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/1-b99deb05dadf108ffd8ef094ec818ab4.png";